import p from './paragraphs';

const _default = {
  color: 'main.2',
  fontFamily: 'body',
  fontSize: 2,
  fontWeight: 500,
  mb: 2,
  display: 'block',
  '>span': { color: 'error' },
};

const error = {
  ..._default,
  color: 'error',
  '>span': { color: 'error' },
};

const sideLabel = {
  fontFamily: 'body',
  fontSize: 3,
  fontWeight: 0,
  ml: 2,
  '>label': {
    fontSize: 3,
    fontWeight: 0,
    mb: 0,
  },
};

const radioGroupItemLabel = {
  fontSize: 3,
  fontWeight: 0,
  display: 'flex',
  alignItems: 'center',
};

const borderBottomSolid = {
  pb: [null, null, '3px'],
  borderBottom: [null, null, '1px solid'],
  borderBottomColor: [null, null, 'lightMain1'],
};

const sustainability = {
  ...p.captionRegularSmall,
  ...borderBottomSolid,
};

const reviews = {
  ...p.captionRegularSmall,
  ...borderBottomSolid,
  fontWeight: 0,
  width: 'fit-content',
};

const labels = {
  _default,
  error,
  sideLabel,
  radioGroupItemLabel,
  sustainability,
  reviews,
};

export default labels;
